import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Estimator from "./vehicles/Estimator";
import SimpleForm from "./vehicles/SimpleForm";
import LandingLongForm from "./landings/LandingLongForm";
import LandingMinimal from "./landings/LandingMinimal";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { initPixel } from "./lib/pixel";
import "./index.css";

// Meta Pixel (F1.4) — no-op si VITE_META_PIXEL_ID no está configurado.
initPixel();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        {/* Vehículo hero */}
        <Route path="/estimator" element={<Estimator />} />
        {/* Simple form (baja fricción) */}
        <Route path="/start" element={<SimpleForm />} />
        {/* Variaciones de landing (mismo webhook vía el estimador) */}
        <Route path="/l/story" element={<LandingLongForm />} />
        <Route path="/l/minimal" element={<LandingMinimal />} />
        {/* Legales (requeridas por Meta + carriers A2P + TCPA) */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
